// Shared Tailwind class strings for the segmented-pill pattern (slate-100
// container, white-shadow active segment) used by both SegmentedControl and
// ScopeSelector. Kept in one place so a brand tweak to the segment look can
// never drift between the two implementations.

export const SEGMENT_CONTAINER =
  "inline-flex gap-0 p-0.5 rounded-md bg-slate-100 dark:bg-slate-700";

export const SEGMENT_BASE =
  "px-3.5 py-1.5 text-body-sm font-medium rounded transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-1";

export const SEGMENT_ACTIVE =
  "bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 shadow-sm";

export const SEGMENT_INACTIVE =
  "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200";
